module.exports = __webpack_public_path__ + "static/media/heart32.613916de.svg";